module.exports = __webpack_public_path__ + "media/put2.d6e0a9a8.mp4";